import { FC } from 'react';
import ProTimePicker, { TimePickerProps } from './timePicker';
import ProTimeRangePicker, { TimeRangePickerProps } from './rangePicker';

export type ITimePickerComponent = FC<TimePickerProps> & {
  RangePicker: FC<TimeRangePickerProps>;
};

const TransTimePicker = ProTimePicker as ITimePickerComponent;
TransTimePicker.RangePicker = ProTimeRangePicker;

export default TransTimePicker;
